import { render, staticRenderFns } from "./StaffScanTemperatureWithBarCode.vue?vue&type=template&id=0479d7be&scoped=true"
import script from "./StaffScanTemperatureWithBarCode.vue?vue&type=script&lang=js"
export * from "./StaffScanTemperatureWithBarCode.vue?vue&type=script&lang=js"
import style0 from "./StaffScanTemperatureWithBarCode.vue?vue&type=style&index=0&id=0479d7be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0479d7be",
  null
  
)

export default component.exports